<template>
    <div class="list-layer-wrap">
<!--        <div class="btn-wrap">-->
            <img :src="newClose" alt="" class="close-btn" @click="closeLayer">
<!--        </div>-->
        <p class="list-title">
            选择单位名称
        </p>
        <div class="list-wrap">
            <div class="search-group-wrap">
                <div class="input-wrap">
                    <Input 
                        v-model="inputVal" 
                        icon="ios-search"
                        clearable
                        placeholder="请输入单位名称" 
                        @on-click="inputSearch"
                        @on-enter="inputSearch"
                    />
                </div>
                <div class="select-wrap">
                    <Select v-model="areaCode" 
                        transfer :word-wrap="true" 
                        clearable 
                        placeholder="所属区域"
                        style="width:100px"
                        @on-change="selectChange"
                    >
                        <Option 
                            v-for="item in areaArr" 
                            :value="item.value" 
                            :key="item.value"
                        >
                            {{ item.label }}
                        </Option>
                    </Select>
                </div>
                <div class="select-wrap">
                    <Select v-model="indusCode" 
                        transfer :word-wrap="true" 
                        clearable 
                        placeholder="所属行业" 
                        style="width:100px"
                        @on-change="selectChange"
                    >
                        <Option 
                            v-for="item in indusArr" 
                            :value="item.value" 
                            :key="item.value"
                        >
                            {{ item.label }}
                        </Option>
                    </Select>
                </div>
            </div>
            <div class="result-wrap table-wrap">
                <div class="t-head">
                    <table>
                        <tr>
                            <th width="50%">
                                单位名称
                            </th>
                            <th width="15%">
                                负责人
                            </th>
                            <th width="35%">
                                联系方式
                            </th>
                        </tr>
                    </table>
                </div>
                <div class="t-body" id="base-layer-list">
                    <table v-show="listArr.length">
                        <tr 
                            v-for="(item, index) in listArr" 
                            :key="index" 
                            :class="{'active': tdIndex === index, 'hoverActive': hoverIndex === index}" 
                            @click="showDetailLayer(item.orgId, index, item)"  
                            @mouseover="mouseOver(index)"
                            @mouseleave="mouseLeave"
                        >
                            <td width="50%">
                                <Poptip
                                    v-if="item.name"
                                    trigger="hover"
                                    transfer :word-wrap="true"
                                    :content="item.name"
                                >
                                    {{item.name}}
                                </Poptip>
                            </td>
                            <td width="15%">
                                <Poptip
                                    v-if="item.leader"
                                    trigger="hover"
                                    transfer :word-wrap="true"
                                    :content="item.leader"
                                >
                                    {{item.leader}}
                                </Poptip>
                            </td>
                            <td width="35%">
                                <Poptip
                                    v-if="item.leaderPhone"
                                    trigger="hover"
                                    transfer :word-wrap="true"
                                    :content="item.leaderPhone"
                                >
                                    {{item.leaderPhone}}
                                </Poptip>
                            </td>
                        </tr>
                    </table>
                    <div 
                        class="more-btn-wrap" 
                        v-show="listArr.length && (listArr.length < totalCount)"
                        @click="getMoreData"
                        >
                        <div class="btn">
                            <i class="iconfont">&#xe60e;</i>
                            <span>加载更多（剩余{{totalCount - listArr.length}}条）</span>
                        </div>
                    </div>
                    <div class="no_date_box" v-show="noData">
                        暂无数据
                    </div>
                </div>
                <div class="loading" v-show="loading_status">
                    <!-- 加载动画 -->
                    <div class="loading_box" v-show="!listArr.length">
                        <img :src="tableLoad" />
                    </div>
                    <div class="more_data_box" v-show="listArr.length">
                        <img :src="tableMore" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import newClose from '@/assets/img/newClose.png';

import { company_list, area_list, indus_list } from '@/assets/js/url.js';


import tableLoad from '@/assets/img/animation.gif';
import tableMore from '@/assets/img/animation.gif';

export default {
  name:"",    
  data: () => ({
    noData: false, //无数据
    loading_status: false,
    tableLoad,
    tableMore,
    hashValue: '',
    newClose,
    inputVal: '',
    areaCode: '',
    indusCode: '',
    areaArr: [],
    indusArr:[],
    model1: '',
    currentPage: 1,
    listArr: [],
    tdIndex: '',
    hoverIndex: '',
    totalCount: 0,
  }),
  watch: {
    showLayer:{
        handler(newVal, oldVal){
            console.log(newVal);
            
            if(newVal){ //显示弹窗
                this.currentPage = 1,
                //初始化数据
                this.dataInit();
                //获取列表数据
                this.getListData();
                //获取select数据
                this.getSelectData();
            }else{ //关闭弹窗

            }
        },
        immediate: true,
        deep: true
    }
  },
  components: {

  },
  created() {

  },
  mounted() {
    this.hashValue = window.localStorage.getItem('hashValue');
  },
  computed: {
    showLayer(){
        return this.$store.state.baseInfoLayer.listStatus;
    }
  },
  methods: {
      mouseOver: function(index){
          this.hoverIndex =index;
      },
      mouseLeave: function () {
          this.hoverIndex ='';
      },
    dataInit(){ //初始化数据
        this.listArr = [];
        this.noData = false;
        this.loading_status = false;
        this.totalCount = 0;
        this.inputVal = '';
        this.areaCode = '';
        this.indusCode = '';
        this.areaArr = [];
        this.indusAr = [];
    },
    closeLayer(){
        this.hoverIndex = '';
        this.tdIndex = '';
        this.$store.commit('baseInfoLayer', {
            listStatus: false,
        });
    },
    showDetailLayer(id, index, item){ //显示详情弹窗
        this.tdIndex = index;
        this.$store.commit('baseInfoLayer', {
            detailStatus: true,
            baseInfoId: id,
            baseInfoItem: item
        });
    },
    inputSearch(){ //input框搜索
        console.log(this.inputVal);
        this.listArr = [];
        this.totalCount = 0;
        this.getListData();
    },
    selectChange(val){
        console.log(this.areaCode);
        console.log(this.indusCode);
        this.listArr = [];
        this.totalCount = 0;
        this.getListData();
    },
    getMoreData(){
        this.currentPage += 1;
        this.getListData();
    },
    getListData(){
        this.loading_status = true;
        this.noData = false;
        var data = {
            type: 'get',
            url: company_list,
            obj: {
                currentPage: this.currentPage,
                pageSize: 50,
                name: this.inputVal,
                areaId: this.areaCode,
                industryCategory: this.indusCode,
            }
        };
        this.$Axios(data).then((res)=>{
            console.log(res);
            console.log('左侧列表数据');
            this.loading_status = false;
            if(res.data.success){
                if(!res.data.totalCount){ //没有数据
                    this.noData = true;
                    return;
                }
                this.totalCount = res.data.totalCount;
                this.listArr = [...this.listArr, ...res.data.data];
                if(this.currentPage == 1 && this.listArr.length > 0){
                    this.showDetailLayer(this.listArr[0].orgId, 0, this.listArr[0])
                }
                this.$nextTick(()=>{
                    $JQ('#base-layer-list').mCustomScrollbar(
                        // {
                        //     callbacks:{
                        //         onTotalScroll:function(){
                        //             if(_this.listArr.length == res.data.totalCount){
                        //                 console.log('没有更多数据');
                        //                 return;
                        //             }else{
                        //                 console.log('加载更多');
                        //                 _this.currentPage += 1;
                        //                 _this.getListData();
                        //             }
                        //         }
                        //     }
                        // }
                    );
                });
            }
        });
    },
    getSelectData(){
          let _this=this;
        const areaDataFn = function(){ //获取所属区域数据
            return new Promise((resolve, reject)=>{
                var orgId = JSON.parse(localStorage.getItem('loginData')).orgId;
                var data = {
                    type: 'get',
                    url: '/mcbw/departments/org/area',
                    obj: {
                        pageSize: 1000,
                        currentPage: 1,
                    }
                    // url: area_list,
                    // obj: {
                    //     orgId: orgId,
                    // }
                };
                _this.$Axios(data).then((res)=>{
                    console.log(res);
                    console.log('所属区域数据');
                    if(res.data.success){
                        resolve(res.data.data);
                    }
                });
            });
        }

        const indusDataFn = function (params) { //获取所属行业数据
            return new Promise((resolve, reject)=>{
                var data = {
                    type: 'get',
                    url: indus_list,
                    obj: {
                        currentPage: _this.currentPage,
                        pageSize: 50,
                    }
                };
                _this.$Axios(data).then((res)=>{
                    console.log(res);
                    console.log('所属行业数据');
                    if(res.data.success){
                        resolve(res.data.data);
                    }
                });
            })
        }


        async function getData() {
            const areaData = await areaDataFn();
            const indusData = await indusDataFn();
            _this.areaArr = [];
            for(let i = 0; i< areaData.length; i++){
                let obj = {
                    value: areaData[i].id,
                    label: areaData[i].name,
                }
                _this.areaArr.push(obj);
            }
            _this.indusArr = [];
            for(let i = 0; i< indusData.length; i++){
                let obj = {
                    value: indusData[i].value,
                    label: indusData[i].name,
                }
                _this.indusArr.push(obj);
            }
        }
        getData();
    },

  }
}
</script>
<style lang="scss" scoped>
.list-layer-wrap{
    position: absolute;
    top: 87px;
    left: 0;
    color: #fff;
    height: calc(100vh - 87px);
    width: 505px;
    background: #041936;
    padding-right: 25px;
    padding-top: 15px;
    z-index: 160;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    background-image: url("../assets/img/listBackGround.png");
    background-repeat: no-repeat;
    background-size: 100% 101%;
    background-position:center;
    .btn-wrap{
        overflow: hidden;
    }
    .close-btn{
        width: 20px;
        height: 20px;
        cursor: pointer;
        position: absolute;
        right: 20px;
        top: 18px;
        z-index: 9;
    }
    p.list-title{
        font-size: 16px;
        line-height: 28px;
        padding-left: 20px;
        padding-bottom: 10px;
        height: 38px;
        color: #74D9FF;
        overflow: hidden;
        position: relative;
    }
    .list-wrap{
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;
        padding: 5px 0 20px 20px;
        display: flex;
        flex-direction: column;
        .search-group-wrap{
            margin-bottom: 25px;
            display: flex;
            flex-direction: row;
            .input-wrap{
                flex: 1;
                flex-shrink: 0;
                overflow: hidden;
            }
            .select-wrap{
                margin-left: 15px;
            }
        }
        .result-wrap{
            flex: 1;
            flex-shrink: 0;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            position: relative;
            table{
                width: 100%;
                table-layout: fixed;
                border-collapse: collapse;
                th{
                    font-weight: normal;
                    text-align: left;
                    font-size: 14px;
                    color: #74D9FF;
                    height: 40px;
                    background:#0C2745;
                    padding-left: 15px;
                    &:not(:first-child){
                        border-left: none;
                    }
                    &:nth-child(2){
                        padding-left: 0
                    }
                    &:not(:last-child){
                        border-right: none;
                    }
                }
                td{
                    height: 40px;
                    text-align: left;
                    padding-left: 15px;
                    font-size: 14px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    cursor: pointer;
                    &:nth-child(2){
                        padding-left: 0
                    }
                }
            }
            .t-body{
                flex: 1;
                flex-shrink: 0;
                overflow: hidden;
                tr.active,
                tr.hoverActive{
                  background:#0C2745;
                }
                .no_date_box{
                    text-align: center;
                    color: #08f4f7;
                    line-height: 100px;
                }
            }
            .loading{
                position: absolute;
                left: 0;
                top: 0;
                width: 100%; 
                height: 100%;
                padding-top: 50px;
                display: flex;
                align-items: center;
                justify-content: center;
                background: rgba(0,0,0,.3);
                img{
                    width: 200px;
                }
            }
        }
    }
}
.more-btn-wrap{
    height: 40px;
    display: flex;
    align-items: center;
    .btn{
        display: flex;
        align-items: center;
        font-size: 12px;
        color: #08f4f7;
        padding-left: 10px;
        cursor: pointer;
        i{
            margin: 0 10px;
        }
    }
}
/deep/ .mCSB_scrollTools{
    right: 0!important;
    .mCSB_dragger{
        background: rgba(255,255,255,.3);
        border-radius: 8px;
        .mCSB_dragger_bar{
            width: 8px;
        }
    }
    .mCSB_draggerRail{
        background-color: transparent;
    }
} 
</style>


// WEBPACK FOOTER //
// src/components/base-layer-list.vue